import React from 'react';
import { useCallback } from 'react';
import { INavLink } from '@hwm/ui-lib';
import { AppPaths } from '@infrastructure/routes/routesPaths';
import { SpillGuardFeatureFlags } from '@infrastructure/permissions/permissions';

const getMenu = (): INavLink[] => {
  return [
    {
      label: <>Site Map</>,
      path: AppPaths.spillGuard.path.base.path,
    },
    {
      label: <>Spill&nbsp;Summary</>,
      path: AppPaths.newSpills.path.base.path,
      featureFlag: {
        flag: SpillGuardFeatureFlags.NewSpills,
        modalTitle: <>Spill Summary</>,
        info: {
          title: <>Spill Summary</>,
          description: (
            <>
              New summary page for all the spills in your account. This feature will enable easy export and analysis of
              your sites in SpillGuard, providing a quick snapshot of real-world events to help you prioritize work and
              address any spillages or faults. Additionally, the new ability to snooze alarms will allow you to focus on
              new and changing issues rather than those already being addressed. We believe these updates will greatly
              enhance your ability to manage your sites and respond to events in a timely and efficient manner.
            </>
          ),
          footer: (
            <>
              This is a part of our premium features, please speak to your sales account manager on how to get this
              feature enabled.
            </>
          ),
        },
        videos: [],
      },
    },
  ] as INavLink[];
};

export const useGetLinks = () => {
  const getMenuLinks = useCallback(() => getMenu(), []);

  return {
    getMenu: getMenuLinks,
  };
};
